var EVENTS = {
    ONLINE: 'camera:online',
    OFFLINE: 'camera:offline',
    UNKNOWN: 'camera:unknown'
};

/**
 * CameraStatus
 */
var CameraStatus = function(cssSelector, options) {
    var _defaults = {
        loadTimeout: 60000,
        dataAttr: 'snapshot-stream',
        initialized: null,
        hidden: false
    };
    this.cssSelector = cssSelector;
    this.containers = [];
    this.options = $.extend({}, _defaults, options || {});
    this._init();
    return this;
};

CameraStatus.prototype._init = function() {
    var _this = this;
    $(this.cssSelector).each(function(key, ele) {
      var container = $(ele);
      _this.containers.push(container);
    });
    if (typeof this.options.initialized === 'function') {
        this.options.initialized(_this.containers);
    }
    this._resolveContainers();
    return this;
}

CameraStatus.prototype._resolveContainers = function() {
    var _this = this;
    $.each(this.containers, function(key, container) {
        if (container.data(_this.options.dataAttr)) {
            _this._appendSnapshotStream(container);
        } else {
            _this._fireEvent(container, EVENTS.UNKNOWN); // If snapshot stream not added, we cannot tell if camera is online/offline
        }
    });
}

CameraStatus.prototype._appendSnapshotStream = function(container) {
    var _this = this;
    var img = $('<img/>').attr('src', container.data(this.options.dataAttr));

    // Don't show img when resolving
    if (this.options.hidden) {
        img.css('display', 'none');
    }

    var onError = function(e) {
        img.attr('src', ''); // Unset src - if not unset, FF will continue to try maintain connection event if element is removed from DOM
        img.remove();
        _this._fireEvent(container, EVENTS.OFFLINE);
    }

    // If browser will not report that mjpeg stream is loaded, camera offline
    var loadTimeout = setTimeout(onError, this.options.loadTimeout);

    // Camera id offline
    img.on('error', onError);

    // Camera is Online
    img.on('load', function(e) {
      _this._fireEvent(container, EVENTS.ONLINE);
      clearTimeout(loadTimeout);
    });

    container.append(img);
}

CameraStatus.prototype._fireEvent = function(container, eventNamespace) {
    container.trigger(eventNamespace);
}

CameraStatus['ONLINE'] = EVENTS.ONLINE;
CameraStatus['OFFLINE'] = EVENTS.OFFLINE;
CameraStatus['UNKNOWN'] = EVENTS.UNKNOWN;

module.exports = CameraStatus;



// WEBPACK FOOTER //
// ./src/resources/js/cameraStatus.js